import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {FlexLayoutModule} from '@angular/flex-layout';
import {DirectiveLibraryModule} from '../../directives/directive-library.module';
import {AngularMaterialLibraryModule} from '../../angular-material/angular-material-library.module';
import {CustomAddressComponent} from './custom-address.component';

const modules = [
  CommonModule,
  FormsModule,
  ReactiveFormsModule,
  FlexLayoutModule,
  AngularMaterialLibraryModule,
  DirectiveLibraryModule,
];

@NgModule({
    imports: [
        ...modules,
        CustomAddressComponent,
    ],
    exports: [
        ...modules,
        CustomAddressComponent,
    ]
})
export class AddressModule {

}
